import React from "react";
import inmersialIcon from "../../assets/inmersial-logo-white.png";
import phoneIcon from "../../assets/phone-circ-icon.png";
import { ELEVENLABS_STATUS } from "./elevenLabsStatus";

const ElevenLabsButton = ({
  texto = "Hablemos",
  onClick,
  status = "idle",
  phoneColor,
}) => {
  const config = ELEVENLABS_STATUS[status] || ELEVENLABS_STATUS.idle;
  const pillColor = phoneColor && status === "idle" ? phoneColor : config.color;
  const label = status === "idle" ? texto : config.label;

  return (
    <div
      onClick={onClick}
      title={status === "connected" ? "Terminar llamada" : "Iniciar asistente de voz"}
      style={{
        display: "inline-flex",
        alignItems: "center",
        backgroundColor: "#ffffff",
        borderRadius: "50px",
        padding: "5px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.22)",
        gap: "6px",
        cursor: "pointer",
        userSelect: "none",
        animation: config.pulso ? "elevenPulso 1.8s ease-in-out infinite" : "none",
      }}
    >
      {/* Inmersial icon — fondo blanco fijo */}
      <div
        style={{
          width: "36px",
          height: "36px",
          borderRadius: "50%",
          backgroundColor: "#ffffff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          overflow: "hidden",
        }}
      >
        <img
          src={inmersialIcon}
          alt="Inmersial"
          style={{ width: "28px", height: "28px", objectFit: "contain" }}
        />
      </div>

      {/* Phone pill */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          backgroundColor: pillColor,
          borderRadius: "50px",
          padding: "8px 16px 8px 10px",
          transition: "background-color 0.25s ease",
        }}
      >
        <img
          src={phoneIcon}
          alt="llamar"
          style={{ width: "20px", height: "20px", objectFit: "contain" }}
        />
        <span
          style={{
            color: "#ffffff",
            fontWeight: 600,
            fontSize: "15px",
            whiteSpace: "nowrap",
            lineHeight: 1,
          }}
        >
          {/* {label} */}
        </span>
      </div>

      <style>{`
        @keyframes elevenPulso {
          0%, 100% { box-shadow: 0 4px 20px rgba(0,0,0,0.22), 0 0 0 0 rgba(239,68,68,0.4); }
          50% { box-shadow: 0 4px 20px rgba(0,0,0,0.22), 0 0 0 8px rgba(239,68,68,0); }
        }
      `}</style>
    </div>
  );
};

export default ElevenLabsButton;
